/* eslint-disable import/prefer-default-export */
// import libs
import store from '@/store'
import { getData } from '@core/utils/http/general'
// import { ref } from '@vue/composition-api'

// detalle de la factura
export const detailFactura = (IdFact, Idorden, idTran) => new Promise((resolve, reject) => {
  const webservice = (!store.state.cuenta.session.token) ? 'wsinscripcion' : 'wscompras'
  const paramsRequest = {
    action: 10,
    IdFact,
    orden: Idorden,
    idTran,
    token: store.state.cuenta.session.token,
  }
  getData(paramsRequest, webservice)
    .then(response => {
      if (response.status === 500) {
        reject(response.data.message)
      } else resolve(response.data)
    })
    .catch(err => { reject(err) })
})

// cabecera de calificaciones profesor
export const cabecerakardex = (plan, curso) => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 1,
    idplan: plan,
    idcurso: curso,
    token: store.state.cuenta.session.token,
  }
  getData(paramsRequest, 'wsreportes')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) {
        resolve(response.data)
      } else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})
